import { Colors } from "@eai-toolkit-material-ui/theme";
import { styled, Tooltip, Typography } from "@mui/material";
import React from "react";

import { useAppSelector } from "../../../store/hooks";

const AvatarContainer = styled("div")<{ hasClickHandler: boolean }>(
  ({ hasClickHandler }) => ({
    height: 40,
    width: 40,
    borderRadius: "3px",
    backgroundColor: Colors.purple[50],
    textTransform: "uppercase",
    display: "grid",
    placeContent: "center",
    cursor: hasClickHandler ? "pointer" : "default",
  }),
);

const Text = styled(Typography)(() => ({
  marginTop: "-1px",
}));

type Props = {
  onClick?: () => void;
  showTooltip?: boolean;
};

const Avatar = React.forwardRef<HTMLDivElement, Props>(
  ({ onClick, showTooltip }, ref) => {
    const user = useAppSelector((state) => state.auth.user);
    if (user === null) {
      return null;
    }
    const displayName = (user.name || user.mail || "").match(/[a-z]/i);

    const content = (
      <AvatarContainer
        ref={ref}
        onClick={onClick || undefined}
        hasClickHandler={!!onClick}
      >
        <Text variant="body1">{displayName}</Text>
      </AvatarContainer>
    );

    return showTooltip ? (
      <Tooltip title={user.mail}>{content}</Tooltip>
    ) : (
      content
    );
  },
);

Avatar.displayName = "Avatar";

export default Avatar;
